import { FormHelperText } from "@mui/material";
import {
  FastField,
  Field,
  FieldInputProps,
  FieldMetaProps,
  FormikProps,
} from "formik";
import { ReactElement } from "react";

import Table, { TableProps } from "../Table";

export type FormikTableProps<R extends { id: string }> = TableProps<R> & {
  name: string;
  shouldUpdate?: (props: any, prevProps: any) => boolean;
  fast?: boolean;
  bottomLabel?: string;
};
export default function FormikTableSelectField<R extends { id: string }>({
  name,
  shouldUpdate,
  fast,
  bottomLabel,
  ...childProps
}: FormikTableProps<R>): ReactElement {
  const Component = fast ? FastField : Field;
  return (
    <Component name={name} shouldUpdate={shouldUpdate}>
      {({
        field,
        meta,
        form,
      }: {
        field: FieldInputProps<string[]>;
        meta: FieldMetaProps<string[]>;
        form: FormikProps<unknown>;
      }) => {
        const error = meta.touched && Boolean(meta.error);
        const helperText = error ? meta.error : bottomLabel;
        return (
          <>
            <Table
              {...childProps}
              selectedRows={field.value}
              onChangeSelectedRows={newRows => {
                form
                  .setFieldValue(name, newRows)
                  .catch(e =>
                    console.error("Error setting table form value", e)
                  );

                return undefined;
              }}
              size="small"
              containerSx={{ overflowX: "visible" }}
            />
            {helperText && (
              <FormHelperText error={error}>{helperText}</FormHelperText>
            )}
          </>
        );
      }}
    </Component>
  );
}
